export const TicketList = ({tickets,visibleCount,ticketsRef,isUiDisabled,handleTicketCardClick,formatDate}) => {
    return (
    <div className="col-12 col-md-6 d-flex flex-column gap-2">
            {tickets.slice(0, visibleCount).map((ticket, index) => (
              <div
                ref={ticketsRef}
                className="col-lg-12"
                key={ticket.id || index}
              >
                <div
                  className={`card border-1 wynston-border ${isUiDisabled ? "disabled-ticket" : ""}`}
                  role={isUiDisabled ? "presentation" : "button"}
                  onClick={() => {
                    if (isUiDisabled) return;
                    handleTicketCardClick(ticket.id);
                  }}
                  data-bs-toggle={isUiDisabled ? undefined : "tooltip"}
                  data-bs-placement={isUiDisabled ? undefined : "top"}
                  title={ticket.shortDescription}
                >
                  <div className="card-body p-2">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <p className="mb-1 wynston-font-colour fw-semibold">
                        {ticket.formattedReference}
                      </p>
                      <small className="wynston-font-colour fw-semibold">
                        {formatDate(ticket.date)}
                      </small>
                    </div>

                    <p className="text-truncate mb-0">{ticket.shortDescription}</p>
                  </div>
                </div>
              </div>              
            ))}
            
          </div>       
    )
}